import type {
  CreatableSpaceView,
  ListCreatableSpacesResponseType,
  PortalInstanceType,
} from '../../__generated__/chirp/com/hubspot/portals/platform/app/rpc/SpaceEligibilityRpc';

export type CreatableSpace = {
  portalInstanceType: PortalInstanceType;
  displayName: string;
  // Root-relative path the consuming app navigates to in order to start the
  // space creation flow. Any optional route params (e.g. the trailing
  // ":portalInstanceId?" segment) are stripped since no instance exists yet.
  setupPath: string;
  locked: boolean;
};

export type CreatableSpacesData = {
  creatableSpaces: CreatableSpace[];
  loading: boolean;
};

export type BuildCreatableSpacesInput = {
  data: ListCreatableSpacesResponseType | undefined;
  loading: boolean;
};

// setupBasePath is a type-relative template such as "/billing/:portalInstanceId?".
// The service intentionally never resolves it to an instance — creation happens
// before an instance exists — so we drop every ":param" segment and leave the
// static prefix the consuming app routes against.
export function resolveSpaceSetupPath(setupBasePath: string): string {
  const resolved = setupBasePath
    .split('/')
    .filter((segment) => !segment.startsWith(':'))
    .join('/');
  if (resolved === '') return '/';
  return resolved.length > 1 ? resolved.replace(/\/$/, '') : resolved;
}

export function buildCreatableSpaces({
  data,
  loading,
}: BuildCreatableSpacesInput): CreatableSpacesData {
  const creatableSpaces = (data?.creatableSpaces ?? []).map(
    (space: CreatableSpaceView): CreatableSpace => ({
      portalInstanceType: space.portalInstanceType,
      displayName: space.displayName,
      setupPath: resolveSpaceSetupPath(space.setupBasePath),
      locked: space.locked,
    })
  );

  return { creatableSpaces, loading };
}
